/* ==========================================================================
   Auren Yorumlar — arayüz davranışları
   Bağımlılık yok. Tüm yorum HTML'i sunucu tarafında basılır; bu dosya
   sadece etkileşim katmanıdır, içerik render etmez.
   ========================================================================== */

(function () {
  'use strict';

  var STAR = '<svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path d="M10 1.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8L10 14.9 4.8 17.6l1-5.8L1.6 7.7l5.8-.8z"/></svg>';

  function el(root, sel) { return root.querySelector(sel); }
  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ---------------------------------------------------------------- Modal */

  function openModal(modal) {
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var focusable = modal.querySelector('input, textarea, button');
    if (focusable) focusable.focus();
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function wireModal(modal) {
    if (!modal) return;
    all(modal, '[data-rv-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeModal(modal); });
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal(modal);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    all(document, '.auren-rv__modal.is-open').forEach(closeModal);
  });

  /* ------------------------------------------------------------- Lightbox */

  function initLightbox(section) {
    var box = el(section, '[data-rv-lightbox]');
    if (!box) return;

    var img = el(box, '[data-rv-lightbox-img]');
    var meta = el(box, '[data-rv-lightbox-meta]');
    var photos = [];
    var index = 0;

    function show(i) {
      if (!photos.length) return;
      index = (i + photos.length) % photos.length;
      var p = photos[index];
      img.src = p.getAttribute('data-rv-full') || p.querySelector('img').src;
      img.alt = p.getAttribute('data-rv-alt') || 'Müşteri yorumu fotoğrafı';
      meta.textContent = p.getAttribute('data-rv-caption') || '';
    }

    function refresh() {
      photos = all(section, '[data-rv-photo]').filter(function (p) {
        var card = p.closest('.auren-rv__card');
        return !card || !card.hidden;
      });
    }

    section.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-rv-photo]');
      if (!trigger) return;
      refresh();
      var start = photos.indexOf(trigger);
      show(start < 0 ? 0 : start);
      openModal(box);
    });

    var prev = el(box, '[data-rv-prev]');
    var next = el(box, '[data-rv-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'ArrowLeft') show(index - 1);
      if (e.key === 'ArrowRight') show(index + 1);
    });
  }

  /* -------------------------------------------------------------- Filtrele */

  function initFilters(section) {
    var chips = all(section, '[data-rv-filter]');
    if (!chips.length) return;

    var cards = all(section, '.auren-rv__card');
    var moreBtn = el(section, '[data-rv-more]');
    var empty = el(section, '[data-rv-empty]');
    var step = parseInt(section.getAttribute('data-rv-step'), 10) || 6;

    function apply(filter) {
      var shown = 0;
      var matching = cards.filter(function (card) {
        if (filter === 'all') return true;
        if (filter === 'photo') return card.getAttribute('data-rv-has-photo') === 'true';
        return card.getAttribute('data-rv-rating') === filter;
      });

      cards.forEach(function (card) { card.hidden = true; });
      matching.forEach(function (card) {
        if (shown < step) { card.hidden = false; shown++; }
      });

      if (empty) empty.hidden = matching.length > 0;
      if (moreBtn) moreBtn.hidden = matching.length <= shown;
      section.setAttribute('data-rv-visible', String(shown));
      section.setAttribute('data-rv-active', filter);
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        apply(chip.getAttribute('data-rv-filter'));
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        var filter = section.getAttribute('data-rv-active') || 'all';
        var visible = parseInt(section.getAttribute('data-rv-visible'), 10) || step;
        var revealed = 0;
        var remaining = 0;

        cards.forEach(function (card) {
          var matches =
            filter === 'all' ||
            (filter === 'photo' && card.getAttribute('data-rv-has-photo') === 'true') ||
            card.getAttribute('data-rv-rating') === filter;
          if (!matches || !card.hidden) return;
          if (revealed < step) { card.hidden = false; revealed++; }
          else remaining++;
        });

        section.setAttribute('data-rv-visible', String(visible + revealed));
        moreBtn.hidden = remaining === 0;
      });
    }

    apply('all');
  }

  /* ------------------------------------------------------- Faydalı buldum */

  function initHelpful(section) {
    var proxy = section.getAttribute('data-rv-proxy');
    section.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-rv-helpful]');
      if (!btn || btn.disabled) return;

      var id = btn.getAttribute('data-rv-helpful');
      var countEl = btn.querySelector('[data-rv-helpful-count]');
      btn.disabled = true;

      var body = new FormData();
      body.append('review_id', id);

      fetch(proxy + '/helpful', { method: 'POST', body: body })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.ok && countEl) countEl.textContent = data.helpful;
        })
        .catch(function () { btn.disabled = false; });
    });
  }

  /* ------------------------------------------------------------------ Form */

  function initForm(section) {
    var modal = el(section, '[data-rv-form-modal]');
    if (!modal) return;

    var form = el(modal, '[data-rv-form]');
    var proxy = section.getAttribute('data-rv-proxy');
    var files = [];

    all(section, '[data-rv-open-form]').forEach(function (btn) {
      btn.addEventListener('click', function () { openModal(modal); });
    });

    /* Yıldız seçici */
    var picker = el(form, '[data-rv-starpick]');
    var ratingInput = el(form, 'input[name="rating"]');
    for (var i = 1; i <= 5; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.innerHTML = STAR;
      b.setAttribute('data-value', String(i));
      b.setAttribute('aria-label', i + ' yıldız');
      picker.appendChild(b);
    }

    function paint(value) {
      all(picker, 'button').forEach(function (btn) {
        btn.classList.toggle('is-active', Number(btn.getAttribute('data-value')) <= value);
      });
    }

    picker.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      ratingInput.value = btn.getAttribute('data-value');
      paint(Number(ratingInput.value));
    });

    picker.addEventListener('mouseover', function (e) {
      var btn = e.target.closest('button');
      if (btn) paint(Number(btn.getAttribute('data-value')));
    });

    picker.addEventListener('mouseleave', function () {
      paint(Number(ratingInput.value) || 0);
    });

    /* Fotoğraf seçici */
    var drop = el(form, '[data-rv-drop]');
    var fileInput = el(form, 'input[type="file"]');
    var previews = el(form, '[data-rv-previews]');
    var maxPhotos = parseInt(section.getAttribute('data-rv-max-photos'), 10) || 5;

    drop.addEventListener('click', function () { fileInput.click(); });

    fileInput.addEventListener('change', function () {
      Array.prototype.forEach.call(fileInput.files, function (file) {
        if (files.length >= maxPhotos) return;
        if (!/^image\//.test(file.type)) return;
        files.push(file);
      });
      fileInput.value = '';
      renderPreviews();
    });

    function renderPreviews() {
      previews.innerHTML = '';
      files.forEach(function (file, idx) {
        var wrap = document.createElement('div');
        wrap.className = 'auren-rv__preview';

        var img = document.createElement('img');
        img.src = URL.createObjectURL(file);
        img.alt = 'Auren müşteri fotoğrafı yükleme önizleme';
        wrap.appendChild(img);

        var rm = document.createElement('button');
        rm.type = 'button';
        rm.textContent = '×';
        rm.setAttribute('aria-label', 'Fotoğrafı kaldır');
        rm.addEventListener('click', function () {
          files.splice(idx, 1);
          renderPreviews();
        });
        wrap.appendChild(rm);

        previews.appendChild(wrap);
      });
      drop.setAttribute('data-count', String(files.length));
    }

    /* Gönderim */
    /* Mesaj kutusu formun DIŞINDA duruyor — modal üzerinden seçilmeli.
       Form içinde aranırsa null döner ve tüm geri bildirim zinciri kırılır. */
    var msg = el(modal, '[data-rv-msg]');
    var submit = el(form, '[data-rv-submit]');

    function reset() {
      if (!submit) return;
      submit.disabled = false;
      submit.textContent = 'Yorumu Gönder';
    }

    function showMessage(text, kind) {
      if (!msg) {
        alert(String(text).replace(/<[^>]*>/g, ' '));
        return;
      }
      msg.className = 'auren-rv__msg auren-rv__msg--' + kind;
      msg.innerHTML = text;
      msg.hidden = false;
      try { msg.scrollIntoView({ block: 'nearest' }); } catch (e) {}
    }

    /* Kod kopyalama — panoya erişim yoksa metni seçili hale getirir */
    function wireCopy() {
      if (!msg) return;
      var btn = msg.querySelector('[data-rv-copy]');
      if (!btn) return;

      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-rv-copy');

        function ok() {
          btn.textContent = 'Kopyalandı ✓';
          setTimeout(function () { btn.textContent = 'Kodu Kopyala'; }, 2500);
        }

        function fallback() {
          var node = msg.querySelector('[data-rv-code]');
          if (!node) return;
          try {
            var range = document.createRange();
            range.selectNodeContents(node);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            if (document.execCommand('copy')) ok();
            else btn.textContent = 'Kodu elle kopyala';
          } catch (e) {
            btn.textContent = 'Kodu elle kopyala';
          }
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(ok, fallback);
        } else {
          fallback();
        }
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!ratingInput.value) {
        showMessage('Lütfen bir puan seçin.', 'error');
        return;
      }

      var body = new FormData(form);
      body.delete('photos');
      files.forEach(function (file) { body.append('photos', file, file.name); });

      submit.disabled = true;
      submit.textContent = 'Gönderiliyor…';
      if (msg) msg.hidden = true;

      /* Sunucu hiç cevap vermezse kullanıcı ölü ekranda kalmasın */
      var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 45000);
      var opts = { method: 'POST', body: body };
      if (ctrl) opts.signal = ctrl.signal;

      fetch(proxy + '/submit', opts)
        .then(function (r) {
          /* Proxy yanlış kuruluysa Shopify HTML döner — r.json() sessizce patlar */
          return r.text().then(function (text) {
            try {
              return JSON.parse(text);
            } catch (err) {
              throw new Error('Sunucu beklenmeyen bir cevap döndü (' + r.status + ').');
            }
          });
        })
        .then(function (data) {
          clearTimeout(timer);

          if (!data.ok) {
            showMessage(data.error || 'Bir sorun oluştu, lütfen tekrar deneyin.', 'error');
            reset();
            return;
          }

          var html = '<p>Yorumun için teşekkürler.</p>';
          if (data.reward) {
            var gun = data.reward.validDays || 15;
            html +=
              '<p>Bir sonraki siparişinde geçerli %' + data.reward.percent +
              ' indirim kodun:</p>' +
              '<code class="auren-rv__code" data-rv-code>' + data.reward.code + '</code>' +
              '<button type="button" class="auren-rv__btn auren-rv__btn--primary" ' +
              'style="width:100%" data-rv-copy="' + data.reward.code + '">Kodu Kopyala</button>' +
              '<p style="font-size:13px;margin-top:16px">Kodu e-posta olarak da gönderdik. ' +
              gun + ' gün geçerli.</p>';
          }
          if (data.moderated) {
            html += '<p style="font-size:13px">Yorumun kısa bir kontrolden sonra yayınlanacak.</p>';
          }

          form.innerHTML = '';
          showMessage(html, 'ok');
          wireCopy();
        })
        .catch(function (err) {
          clearTimeout(timer);
          var text =
            err && err.name === 'AbortError'
              ? 'İstek zaman aşımına uğradı. Lütfen tekrar deneyin.'
              : (err && err.message) || 'Bağlantı kurulamadı. Lütfen tekrar deneyin.';
          showMessage(text, 'error');
          reset();
          if (window.console) console.error('Auren yorum gönderimi:', err);
        });
    });

    /* Derin bağlantı — QR kart, e-posta daveti, SMS linki.
       ?yorum=1 ile açılır. Ayrıca basılı kartlarda kalan eski Loox
       çapaları (#looxReviews vb.) da buraya yönlendirilir. */
    (function deepLink() {
      var params = new URLSearchParams(window.location.search);
      var iste = params.get('yorum') || params.get('review');
      var hash = (window.location.hash || '').toLowerCase();
      var capa =
        hash.indexOf('loox') !== -1 ||
        hash === '#yorum-yaz' ||
        hash === '#yorumlar' ||
        hash === '#reviews';
      if (!iste && !capa) return;

      var mail = params.get('eposta') || params.get('email');
      var isim = params.get('isim') || params.get('name');
      var puan = parseInt(params.get('puan') || params.get('rating'), 10);

      var alanMail = el(form, 'input[name="email"]');
      var alanIsim = el(form, 'input[name="name"]');
      if (mail && alanMail) alanMail.value = mail;
      if (isim && alanIsim) alanIsim.value = isim;
      if (puan >= 1 && puan <= 5) {
        ratingInput.value = String(puan);
        paint(puan);
      }

      /* Sayfa yerleşimi oturmadan kaydırma yaparsak yanlış yere gider */
      setTimeout(function () {
        try {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e) {
          section.scrollIntoView();
        }
        openModal(modal);
      }, 350);
    })();
  }

  /* ------------------------------------------------------------------ Init */

  function init() {
    all(document, '[data-rv-section]').forEach(function (section) {
      if (section.hasAttribute('data-rv-ready')) return;
      section.setAttribute('data-rv-ready', 'true');

      all(section, '.auren-rv__modal').forEach(wireModal);
      initLightbox(section);
      initFilters(section);
      initHelpful(section);
      initForm(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Tema editöründe section yeniden yüklendiğinde */
  document.addEventListener('shopify:section:load', init);
})();